<template>
  <v-row
    row
    dense
    class="pa-2 mx-0"
    :class="this.theme === 'dark' ? 'hyp-details-list-bg' : ''"
  >
    <v-col class="col-12">
      <v-container fluid grid-list-xs class="pa-0">
        <div v-if="!items || !items.length" class="pa-3 hyp-details-list">
          No travelers found matching search criteria
        </div>
        <v-row v-if="itemsList" row wrap dense class="content-row">
          <div
            :id="contentContainerId"
            ref="contentContainer"
            :style="contentStyle"
            class="content-container"
            :class="{
              dark: theme === 'dark',
              light: theme !== 'dark',
            }"
          >
            <v-col
              v-for="(item, index) in itemsList"
              :key="index"
              x12
              class="mb-2 pa-0 col-12"
            >
              <TravelTrackerListClusterItem
                v-if="item"
                :item="item"
                :theme="theme"
              ></TravelTrackerListClusterItem>
            </v-col>
          </div>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
const EMITTED_ACTIONS = {
  LOADED: "loaded",
  GET_DATA: "get-data",
};

export default {
  name: "TravelTrackerListCluster.vue",
  components: {
    TravelTrackerListClusterItem: () =>
      import("@/components/isosTravelTracker/TravelTrackerListClusterItem"),
  },
  props: {
    items: {
      type: Array,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    heightPercent: {
      type: Number,
      default: 50,
    },
    loader: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String,
    },
    scrollToTop: {
      type: String,
    },
  },
  computed: {
    itemsList() {
      return this.items;
    },
    contentContainerId() {
      return "content-container-" + this._uid;
    },
    contentStyle() {
      if (this.listHeight) {
        return {
          "max-height": this.listHeight,
          height: this.listHeight,
        };
      }
      return null;
    },
    listHeight() {
      if (this.heightPixels) {
        return `${this.heightPixels}px`;
      } else if (this.heightPercent) {
        return `${this.heightPercent}vh`;
      }
      return null;
    },
    loaderColor() {
      if (this.theme === "dark") {
        return "white";
      }
      return "black";
    },
  },
  mounted() {
    this.resizeList();
    this.$emit(EMITTED_ACTIONS.LOADED, true);
  },
  updated() {
    this.resizeList();
  },
  methods: {
    resizeList() {
      if (!this.heightPixels) {
        let el = document.getElementById(this.contentContainerId);
        if (el) {
          el.style.height =
            window.innerHeight - el.getBoundingClientRect().y - 5 + "px";
        }
      }
    },
  },
  watch: {
    scrollToTop() {
      this.$refs.contentContainer.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.content-row {
  margin-bottom: 15px;
}
.content-container {
  width: 100% !important;
  overflow-y: auto;
  padding: 2px 10px 0 0;
  margin-bottom: 20px;
  /* firefox specific scollbar props */
  scrollbar-color: #646464 #080811;
  scrollbar-width: thin;
}

/* These are for the scroll bar in the content container */
::-webkit-scrollbar {
  width: 8px;
  height: 3px;
}
.dark::-webkit-scrollbar-track {
  background-color: red; /* #646464; */
  border-radius: 3px;
}
.dark::-webkit-scrollbar-track-piece {
  background-color: #000;
}
.dark::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #666;
  border-radius: 3px;
}
.dark::-webkit-scrollbar-thumb:hover {
  background: black;
}

.light::-webkit-scrollbar-track {
  background-color: #e6e6e6;
  border-radius: 3px;
}
.light::-webkit-scrollbar-track-piece {
  background-color: #e6e6e6;
}
.light::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #b0b0b0;
  border-radius: 3px;
}
.light::-webkit-scrollbar-thumb:hover {
  background: white;
}
</style>
